<!-- 主入口 -->
<template>
    <LevelExplorer :compact="isCompact" />
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import LevelExplorer from './components/level-explorer.vue';

type DeviceType = 'pc' | 'phone' | 'pad';

const getDeviceType = (): DeviceType => {
  const width = window.innerWidth;
  if (width < 768) {
    return 'phone';
  } else if (width < 1024) {
    return 'pad';
  } else {
    return 'pc';
  }
};

const deviceType = ref<DeviceType>(getDeviceType());

const checkDevice = () => {
  deviceType.value = getDeviceType();
};

onMounted(() => {
  // 再次检查以防万一，或者处理 SSR  hydration  mismatch (如果涉及 SSR)
  checkDevice(); 
  window.addEventListener('resize', checkDevice);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkDevice);
});

const isCompact = computed(() => deviceType.value !== 'pc');

</script>

<style>
</style>
